import { useTranslation } from 'react-i18next';
import { useEffect, useRef, useState } from 'react';

export default function AboutSection() {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section 
      ref={sectionRef}
      id="about" 
      className={`py-20 bg-blue-50 transition-all duration-1000 ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'
      }`}
    >
      <div className="container mx-auto px-6">
        <div className={`text-center mb-16 transition-all duration-1000 delay-200 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
        }`}>
          <h2 className="text-4xl font-bold text-gray-800 mb-4">
            {t('about.title')}
          </h2>
          <p className="text-xl text-blue-600 font-medium">
            {t('about.subtitle')}
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div className={`transition-all duration-1000 delay-400 ${
            isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-8'
          }`}>
            <p className="text-lg text-gray-600 leading-relaxed mb-8">
              {t('about.description')}
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-8">
              <div className="text-center">
                <div className="text-4xl font-bold text-blue-500 mb-2">20+</div>
                <p className="text-gray-600 text-sm">{t('about.experience')}</p>
              </div>
              <div className="text-center">
                <div className="text-4xl font-bold text-blue-500 mb-2">500+</div>
                <p className="text-gray-600 text-sm">{t('about.projects')}</p>
              </div>
              <div className="text-center">
                <div className="text-4xl font-bold text-blue-500 mb-2">200+</div>
                <p className="text-gray-600 text-sm">{t('about.clients')}</p>
              </div>
            </div>
          </div>

          <div className={`relative transition-all duration-1000 delay-600 ${
            isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-8'
          }`}>
            <img
              src="/media/other_picture/about.png"
              alt="JSPM Engineering Facility"
              className="w-full h-64 md:h-96 object-cover rounded-lg shadow-lg object-top"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
